import React from "react";
import { useNavigate } from "react-router-dom";
import SEOHead from "../components/SEOHead";

function ResumeBuilder() {
const navigate = useNavigate();

const handleStart = () => {
navigate("/get-started");
};

const btnPrimary = {
backgroundColor: "#007bff",
color: "#fff",
padding: "14px 24px",
borderRadius: "8px",
border: "none",
cursor: "pointer",
marginTop: "20px",
fontWeight: "bold",
fontSize: "16px"
};

return (
  <>
    <SEOHead
      title="Resume Builder"
      description="Build a professional resume in minutes with EmployPilot's Resume Builder. Create resumes, prepare for interviews, and grow your career."
      canonical="https://employpilot.com/resume-builder"
    />

    <div
      style={{
        maxWidth: "1100px",
        margin: "0 auto",
        padding: "60px 20px",
        textAlign: "center"
      }}
    >
      <p
        style={{
          color: "#007bff",
          fontWeight: "600",
          marginBottom: "12px"
        }}
      >
        Resume Builder
      </p>

      <h1
        style={{
          fontSize: "48px",
          fontWeight: "bold",
          lineHeight: "1.15",
          marginBottom: "20px"
        }}
      >
        Build a Professional Resume in Under 30 Seconds.
      </h1>

    <p
      style={{
        fontSize: "18px",
        color: "#555",
        maxWidth: "760px",
        margin: "0 auto",
        lineHeight: "1.7"
      }}
    >
      No complicated resume writing. No long forms. Just enter a few job
      details and let EmployPilot instantly generate a polished resume
      designed to help you land real interviews.
    </p>

    <p
      style={{
        marginTop: "14px",
        fontSize: "14px",
        color: "#777",
        fontWeight: "500"
      }}
    >
      ✔ Secure account • ✔ No credit card required • ✔ AI-powered career tools
    </p>

    <button
      onClick={handleStart}
      style={btnPrimary}
    >
      Start My Resume Now — Free
    </button>

    <p
      style={{
        marginTop: "10px",
        color: "#888",
        fontSize: "14px"
      }}
    >
      Takes less than 2 minutes • Secure signup • Professional PDF downloads
    </p>

    <div
      style={{
        marginTop: "80px",
        background: "#f8f9fa",
        borderRadius: "12px",
        padding: "40px"
      }}
    >
      <h2
        style={{
          fontSize: "32px",
          fontWeight: "bold",
          marginBottom: "20px"
        }}
      >
        Why Job Seekers Use EmployPilot
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
          gap: "25px",
          marginTop: "30px"
        }}
      >
        <div>
          <h3>📄 Resume Builder</h3>
          <p>
            Create professional resumes designed to pass screening systems.
          </p>
        </div>

        <div>
          <h3>🎯 Interview Prep</h3>
          <p>
            Practice answers and prepare for common interview questions.
          </p>
        </div>

        <div>
          <h3>🚀 Career Growth</h3>
          <p>
            Get guidance, resources, and tools to continue growing after you
            get hired.
          </p>
        </div>
      </div>
    </div>

    <div style={{ marginTop: "80px" }}>
      <h2
        style={{
          fontSize: "42px",
          fontWeight: "bold",
          marginBottom: "20px"
        }}
      >
        This Isn't Just a Resume Builder — It's Your Hiring System
      </h2>

      <p
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          color: "#666",
          lineHeight: "1.8"
        }}
      >
        A great resume helps you get noticed. EmployPilot goes further by
        helping you prepare for interviews, organize your job search, and
        continue developing your career long after you land the job.
      </p>

      <div
        style={{
          marginTop: "30px",
          lineHeight: "2"
        }}
      >
        <p>• Resume Builder → Get past resume screening</p>
        <p>• Interview Coach → Know exactly what to say</p>
        <p>• Career Tools → Continue growing professionally</p>
      </div>

      <button
        onClick={handleStart}
        style={btnPrimary}
      >
        Start My Resume Now — Free
      </button>
    </div>
    <div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
</>


);
}

export default ResumeBuilder;

